import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navigation } from "./components/landing/Navigation";
import { Hero } from "./components/landing/Hero";
import { SpiceMarquee } from "./components/landing/SpiceMarquee";
import { Products } from "./components/landing/Products";
import { Story } from "./components/landing/Story";
import { SpiceJourney } from "./components/landing/SpiceJourney";
import { WhyUs } from "./components/landing/WhyUs";
import { Recipes } from "./components/landing/Recipes";
import { Testimonials } from "./components/landing/Testimonials";
import { Newsletter } from "./components/landing/Newsletter";
import { Wholesale } from "./components/landing/Wholesale";
import { Contact } from "./components/landing/Contact";
import { Footer } from "./components/landing/Footer";
import { FloatingWhatsApp } from "./components/landing/FloatingWhatsApp";
import RecipesIndex from "./pages/RecipesIndex";
import RecipeDetail from "./pages/RecipeDetail";
import AdminRecipes from "./pages/AdminRecipes";
import { ScrollToTop } from "./components/ScrollToTop";

const Landing = () => (
  <main data-testid="landing-main" className="relative overflow-x-hidden">
    <Navigation />
    <Hero />
    <SpiceMarquee />
    <Products />
    <Story />
    <SpiceJourney />
    <WhyUs />
    <Recipes />
    <Testimonials />
    <Newsletter />
    <Wholesale />
    <Contact />
    <Footer />
    <FloatingWhatsApp />
  </main>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#2C2520",
            color: "#F9F6F0",
            border: "1px solid rgba(249,246,240,0.15)",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/recipes" element={<RecipesIndex />} />
          <Route path="/recipes/:slug" element={<RecipeDetail />} />
          <Route path="/admin/recipes" element={<AdminRecipes />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
